class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    // Auto-focus search input after modal animation completes
    // Use requestAnimationFrame to ensure the input is rendered and focusable
    this.focusSearchInput();
  }

  /**
   * Focuses the search input field after the modal opens.
   * Uses requestAnimationFrame with a small delay to ensure the modal animation completes
   * and the input element is fully rendered and focusable.
   */
  focusSearchInput() {
    // Double requestAnimationFrame ensures we wait for the next paint cycle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Find the search input within this modal (not the readonly one in the summary)
        const searchInput = this.detailsContainer.querySelector('.search-modal input[type="search"]:not([readonly])');
        
        if (searchInput) {
          try {
            searchInput.focus();
            // If the input has existing text, select it for easy replacement
            if (searchInput.value && searchInput.setSelectionRange) {
              searchInput.setSelectionRange(0, searchInput.value.length);
            }
          } catch (error) {
            // Silently fail if focus is not possible (e.g., element not yet in DOM)
            console.debug('Could not focus search input:', error);
          }
        }
      });
    });
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
